<template>
  <div id="pageRomaneios">
    <v-container grid-list-xs fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <div v-if="!paginatationDisabled">
        <v-card>
          <v-card-text>
            <v-form @submit.prevent="searchTempUsers(1)">
              <v-row dense>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="searchData.id"
                    label="Id"
                  ></v-text-field>
                </v-col>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="searchData.name"
                    label="Nome"
                  ></v-text-field>
                </v-col>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="searchData.email"
                    label="E-mail"
                  ></v-text-field>
                </v-col>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="searchData.cpf"
                    label="CPF"
                  ></v-text-field>
                </v-col>

                <v-col align-self="center" md="3" cols="12">
                  <v-btn
                    @click="searchTempUsers(1)"
                    small
                    class="ma-1"
                    color="primary"
                  >
                    <v-icon class="body-1">fa-search</v-icon>Buscar
                  </v-btn>
                  <v-btn
                    :to="{ name: 'TempUsers' }"
                    small
                    class="ma-1"
                    color="gray"
                    >Limpar</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-text>
            <v-data-table
              v-if="users.data"
              :headers="headers"
              :items="users.data"
              :mobile-breakpoint="960"
              disable-pagination
              hide-default-footer
              disable-sort
              class="animals-table"
            >
              <template v-slot:item.cpf="{ item }">{{
                item.cpf | formatCpf
              }}</template>

              <template v-slot:item.created_at="{ item }">{{
                item.created_at | formatDateHour
              }}</template>

              <template v-slot:item.phone="{ item }">{{
                item.phone | formatPhone
              }}</template>

              <template v-slot:item.actions="{ item }">
                <v-row align-content="center">
                  <v-btn
                    class="ml-1"
                    small
                    :disabled="item.smsSent"
                    @click="resendSmsToTempUser(item)"
                    color="primary"
                    :loading="item.resendSmsLoading"
                  >
                    Re-enviar SMS
                  </v-btn>

                  <v-btn
                    class="ml-1"
                    small
                    :disabled="item.approveUser"
                    @click="approveUser(item)"
                    color="success"
                    :loading="item.approveUser"
                  >
                    Ativar
                  </v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <app-pagination
          v-if="users && users.pagination"
          :pagination="users.pagination"
          :disabled="paginatationDisabled"
          v-on:change-page="searchTempUsers"
        ></app-pagination>
      </div>

      <v-layout row justify-center>
        <v-dialog persistent v-model="deleteUserDialog" max-width="600px">
          <v-card>
            <v-card-title class="error white--text" primary-title>
              <span class="headline">Atenção!</span>
            </v-card-title>
            <v-card-text
              ><v-row class="py-3">
                Para excluir o usuário
                <b class="mx-1">{{ userToDelete.name }}</b> digite sua senha
                abaixo
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="deleteUser">
                Confirmar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="deleteUserDialog = false"
                >Cancelar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import appApi from "../../plugins/api";
import AppPagination from "../../components/Pagination";

import moment from "moment";

export default {
  components: {
    "app-pagination": AppPagination
  },
  data: function() {
    return {
      headers: [
        { text: "Id", value: "id", sortable: false },
        { text: "Nome", value: "name", sortable: false },
        { text: "Telefone", value: "phone", sortable: false },
        { text: "E-mail", value: "email", sortable: false },
        { text: "CPF", value: "cpf", sortable: false },
        { text: "Código", value: "code", sortable: false },
        { text: "Data cadastro", value: "created_at", sortable: false },
        { text: "Ações", value: "actions", sortable: false }
      ],
      users: {},
      currentPage: 1,
      paginatationDisabled: false,
      dialog: false,
      notificationDialog: false,
      snackbarCsv: false,
      updateIdx: null,
      deleteMessage: "",
      loadingCsv: false,
      snackbar: {},
      searchData: {},
      userToDelete: {},
      deleteUserDialog: false
    };
  },

  computed: {},

  mounted: function() {
    if (this.$route.query.page) {
      this.searchData["page"] = this.$route.query.page;
    } else {
      this.searchData["page"] = 1;
    }

    if (this.$route.query.id) {
      this.searchData["id"] = this.$route.query.id;
    }
    if (this.$route.query.name) {
      this.searchData["name"] = this.$route.query.name;
    }
    if (this.$route.query.cpf) {
      this.searchData["cpf"] = this.$route.query.cpf;
    }
    if (this.$route.query.email) {
      this.searchData["email"] = this.$route.query.email;
    }

    this.getData(this.searchData);
  },

  methods: {
    approveUser(item) {
      this.$confirm('Tem certeza que deseja ativar usuário?').then(res => {
        if(res) {
          this.$set(item, 'approveUser', true)
          appApi.postAuthRegister({
            code : item.code, 
            hash : item.hash
          })
            .then(res => {
              this.snackbar = {
                show: true,
                color: "success",
                text: "Usuário ativado com sucesso!"
              };
              this.getData()
            })
            .catch( err => {
              this.snackbar = {
                show: true,
                color: "error",
                text: "Erro ao ativar usuário."
              };
            })
            .finally(() => {
              this.$set(item, 'approveUser', false)
            })
        }
      })
    },
    deleteUserRequest(user) {
      this.deleteUserDialog = true;
      this.password = "";
      this.form.deleteUser.error = false;
      this.form.deleteUser.message = "";
      this.userToDelete = user;
    },

    resendSmsToTempUser(item) {
      item.resendSmsLoading = true;
      appApi
        .resendSmsToTempUser(item.id)
        .then(() => {
          this.snackbar = {
            show: true,
            color: "success",
            text: "SMS re-enviado para o usuário"
          };

          item.smsSent = true;
        })
        .catch(err => {
          this.snackbar = {
            show: false,
            color: "error",
            text: "SMS não enviado"
          };
        })
        .finally(() => {
          item.resendSmsLoading = false;
        });
    },

    searchTempUsers: function(page) {
      let data = { page: page ? page : 1 };

      if (this.searchData.id) {
        data["id"] = this.searchData.id;
      }
      if (this.searchData.name) {
        data["name"] = this.searchData.name;
      }
      if (this.searchData.email) {
        data["email"] = this.searchData.email;
      }
      if (this.searchData.cpf) {
        data["cpf"] = this.searchData.cpf.replace(/\D/g, "");
      }

      this.$router.push({ name: "TempUsers", query: data });
    },

    getData: function(data) {
      this.paginatationDisabled = true;
      this.users.data = [];
      appApi
        .getTempUsers(data)
        .then(result => {
          this.users = result.data;
          this.paginatationDisabled = false;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    deleteUser(answer) {
      appApi
        .deleteUser(this.userToDelete.id, { password: this.password })
        .then(() => {
          this.snackbar = {
            show: true,
            color: "success",
            text: "Usuário deletado com sucesso"
          };

          const userIdxToDel = this.users.data.findIndex(item => {
            return item.id === this.userToDelete.id;
          });

          this.users.data.splice(userIdxToDel, 1);
          this.deleteUserDialog = false;
        })
        .catch(err => {
          if (err.response && err.response.data) {
            for (const e of err.response.data) {
              this.form.deleteUser[e.field].error = true;
              this.form.deleteUser[e.field].message = e.message;
            }
          }
        });
    }
  }
};
</script>
<style scoped lang="css">
>>> .v-data-table-header.v-data-table-header-mobile {
  display: none;


}


.cardtitle{
max-width: 90%;
}
</style>
